import {WordEntry} from "../../WordEntry";
import * as React from "react";
import {Action} from "../App";
import {Button} from "semantic-ui-react";
import {KanaDisplay} from "./KanaDisplay";
import {ActionDisplay} from "./ActionDisplay";
import {StyledQuizCard} from "./StyledQuizCard";

interface QuizProps {
    action: Action,
    word: WordEntry,

    reveal(): void
}

interface QuizState {
}

export class Quiz extends React.Component<QuizProps, QuizState> {
    public render() {
        if (this.props.action !== Action.quiz) {
            return "";
        }

        return (
            <StyledQuizCard>
                <KanaDisplay>
                    {this.props.word.reading}
                </KanaDisplay>
                <ActionDisplay>
                    <Button size='big' onClick={() => this.props.reveal()}>Reveal!</Button>
                </ActionDisplay>
            </StyledQuizCard>

        )
    };
}


// WEBPACK FOOTER //
// ./src/components/QuizBox/Quiz.tsx